export class AvalancheReelsEvents {
	public static readonly REEL_DROP_OUT_FINISHED: string = 'AvalancheReelsEvents::__REEL_DROP_OUT_FINISHED__';
	public static readonly ALL_REELS_DROP_OUT_FINISHED: string = 'AvalancheReelsEvents::__ALL_REELS_DROP_OUT_FINISHED__';
	public static readonly REEL_DROP_NEW_FINISHED: string = 'AvalancheReelsEvents::__REEL_DROP_NEW_FINISHED__';
	public static readonly ALL_REELS_DROP_NEW_FINISHED: string = 'AvalancheReelsEvents::__ALL_REELS_DROP_NEW_FINISHED__';
	public static readonly ALL_REELS_DROP_NEW_STARTED: string = 'AvalancheReelsEvents::__ALL_REELS_DROP_NEW_STARTED__';
	public static readonly FILLING_VOIDS_FINISHED: string = 'AvalancheReelsEvents::__FILLING_VOIDS_FINISHED__';

	public static readonly REMOVING_AVALANCE_SYMBOLS_STARTED: string = 'AvalancheReelsEvents::__REMOVING_AVALANCE_SYMBOLS_STARTED__';
	public static readonly REMOVING_WIN_FINISHED: string = 'AvalancheReelsEvents::__REMOVING_WIN_FINISHED__';
	public static readonly ADDING_NEW_FINISHED: string = 'AvalancheReelsEvents::__ADDING_NEW_FINISHED__';
	public static readonly AVALANCHE_FINISHED: string = 'AvalancheReelsEvents::__AVALANCHE_FINISHED__';

	public static readonly SYMBOLS_RESPIN_STARTED: string = 'AvalancheReelsEvents::__SYMBOLS_RESPIN_STARTED__';
	public static readonly SYMBOLS_RESPIN_FINISHED: string = 'AvalancheReelsEvents::__SYMBOLS_RESPIN_FINISHED__';

	public static readonly RESPIN_REMOVING_SYMBOLS_FINISHED: string = 'AvalancheReelsEvents::RESPIN_REMOVING_SYMBOLS_FINISHED';

	public static readonly REELS_FADING_OUT_FINISHED: string = 'AvalancheReelsEvents::REELS_FADING_OUT_FINISHED';
	public static readonly REELS_FADING_IN_FINISHED: string = 'AvalancheReelsEvents::REELS_FADING_IN_FINISHED';
	public static readonly REELS_FADING_OUT_STARTED: string = 'AvalancheReelsEvents::REELS_FADING_OUT_STARTED';
	public static readonly REELS_FADING_IN_STARTED: string = 'AvalancheReelsEvents::REELS_FADING_IN_STARTED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents.ts